import * as React from 'react';
import * as autoBind from 'react-autobind';
import Image from '../Image/Image';
import MediaDimensionsModel from '../../types/MediaDimensionsModel';

export default class SimpleImage extends React.Component<SimpleImageProps, SimpleImageState> {
   readonly state: SimpleImageState = {mediaDimensions: null};

   constructor(props: SimpleImageProps) {
      super(props);
      autoBind(this);
   }

   setMediaDimensions(mediaDimensions: MediaDimensionsModel) {
      this.setState({mediaDimensions: mediaDimensions});
   }

   render() {
      const {mediaUrl} = this.props;

      return (
         <Image mediaUrl={mediaUrl}
                allowZoom={false}
                allowAnnotation={false}
                mediaDimensions={this.state.mediaDimensions}
                setMediaDimensions={this.setMediaDimensions}/>
      );
   }
}

interface SimpleImageProps {
   mediaUrl: string;
}

interface SimpleImageState {
   mediaDimensions: MediaDimensionsModel;
}
